<template>
  <div id="all-policy" >
    <div class="all-info" ref="coversion">
      <div class="total" ref="total">
        <div class="tag">
          <img class="avatar" :src="userInfo.avatar || require('@/assets/images/personal/avatar.png')" alt="头像">
          <div>
            <p class="nickname">{{userInfo.nickname || ''}}
              <!-- <span @click="toView('/identify')">
                <img :src="userInfo.is_verified? require('@/assets/images/personal/renzheng.png') : require('@/assets/images/personal/no-renzheng.png')" alt="认证">
                {{userInfo.is_verified ? '已认证' : '未认证 >'}}
              </span> -->
            </p>
            <span class="related-icon">
              <img :src="userInfo.is_vip? require('@/assets/images/personal/vip.png') : require('@/assets/images/personal/no-vip.png')" alt="会员">
              {{userInfo.is_vip ? '已成为会员' : '未成为会员 >'}}
            </span>
          </div>
          <!-- <span>去认证 <span class="right_arrows"></span></span> -->
          <span class="news"></span>
        </div>
        <div class="alldata">
          <div class="datatop">
            <div>
              <p>我的家庭保障</p>
              <p>锦鲤保专属定制</p>
            </div>
            <div @click="toMemberInfo">添加保障成员</div>
          </div>
          <div class="data">
            <div class="threesone">
              <img src="../assets/images/policy/home.png" />
              <div>
                <p><span>{{count.family_member}}</span>位</p>
                <p>家庭成员</p>
              </div>
            </div>
            <div class="threesone">
              <img src="../assets/images/policy/care.png" />
              <div>
                <p><span>{{count.insurance}}</span>份</p>
                <p>家庭保险</p>
              </div>
            </div>
            <div class="threesone">
              <img src="../assets/images/policy/perso.png" />
              <div>
                <p><span>{{count.protected_member}}</span>位</p>
                <p>保障家人</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="family-members">
        <div class="title">
          <span>我的家庭保单</span>
          <span @click="toFamilyMemberList">管理成员<i class="right_arrows1"></i></span>
        </div>
        <ul>
          <li :class="`member ${nowChoose == 0 ? 'active': ''}`" @click="createPolicyShowList(0,true)">
            <div class="head">家庭</div>
            <img class="avatar" src="@/assets/images/policy/house.png">
            <span class="name">全部</span>
            <div class="intro">
              <span>{{count.insurance}}</span>份有效保障
            </div>
          </li>
          <li :class="`member ${nowChoose == item.id ? 'active': ''}`" v-for="(item, index) in familyMemberList" :key="index" @click="createPolicyShowList(item.id,true)">
            <div class="head">{{item.role_label}}</div>
            <img class="avatar" :src="require(`@/assets/images/personal/${avatarFomatter(item.role)}.png`)">
            <span class="name">{{item.real_name}}</span>
            <div class="intro">
              <span>{{policy[item.id] ? policy[item.id].length : 0}}</span>份有效保障
            </div>
          </li>
          
        </ul>
        <div class="linecor"></div>        
        
        <transition-group name="hehe" >
          <div class="tab-content "  v-show="!show "  :key="2" >
            <div class="list">
              <div  class="card" v-for="(item, index) in policyShowList" :key="index">
                <div>
                  <p>{{item.product_name}}</p>
                  <p>保障期限：{{item.start_date}} 至 {{item.end_date}}</p>
                </div>
                <span @click="checkDetail(item.policy_id)">查看详情</span>
              </div>
            </div>
          </div>
        </transition-group >
        <transition-group name="hehe" >
          <div class="tab-content "  v-show="show "  :key="2" >
            <div class="list">
              <div class="card" v-for="(item, index) in policyShowList" :key="index">
                <div>
                  <p>{{item.product_name}}</p>
                  <p>保障期限：{{item.start_date}} 至 {{item.end_date}}</p>
                </div>
                <span @click="checkDetail(item.policy_id)">查看详情</span>
              </div>
            </div>
            
          </div>
        </transition-group >
        <transition-group name="hehe" >
          <div v-if="!policyShowList.length" class="nopro" :key="3">
            暂无保障
          </div>
        </transition-group >


        
      </div>
    </div>
    
  </div>
</template>

<script>
// 全部保单
export default {
  name: 'allPolicy',
  data(){
    return{
      userInfo:{},
      count: {},
      policy: {},
      nowChoose: 0,
      pdkey:'',
      policyShowList:[],
      familyMemberList: [],
      show:true,
      shows:false
    }
  },
  methods:{
    // 滚动到页面底部
    scrollToBottom(){
      this.$nextTick(() => {
        var container = this.$refs.coversion
          if(container.scrollTop < this.$refs.total.offsetHeight - 50){
            var xx = setInterval(() => {
              if(container.scrollTop < this.$refs.total.offsetHeight){
                  container.scrollTop = container.scrollTop + 15
              }else{
                container.scrollTop = this.$refs.total.offsetHeight
                clearInterval(xx);
              }
            }, 20);
          }else if(container.scrollTop > this.$refs.total.offsetHeight){
            var yy = setInterval(() => {
              if(container.scrollTop > this.$refs.total.offsetHeight){
                  container.scrollTop = container.scrollTop - 5
              }else{
                container.scrollTop = this.$refs.total.offsetHeight
                clearInterval(yy);
              }
            }, 20);
          }
      })
    },
    // 获取家庭成员列表
    getFamilyMemberList(){
      this.axios({
        method: 'GET',
        url: '/user-family?need=id,role,role_label,real_name',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.familyMemberList = res.data.data
          // this.familyMemberList.unshift({
          //   id: 0,
          //   real_name: "全部",
          //   role: -1,
          //   role_label: "家庭"
          // })
        }
        this.userInfo = this.Storage.get('userBaseInfo')
      })
    },
    // 获取全部保单
    getPolicy(){
      this.axios({
        method: 'GET',
        url: '/policy',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.count = res.data.data.count
          this.policy = res.data.data.policy
          this.createPolicyShowList(0)
        }
      })
    },
    // 生成保单数据
    createPolicyShowList(key,b){
      
      if(b){
        this.scrollToBottom();
      }
      if(this.pdkey === key){
        return;
      }
      // console.log(this.pdkey,key)

      this.show = !this.show;
      this.shows = !this.shows;

      this.nowChoose = key;
      this.pdkey = key;
      this.policyShowList = []
      if(key){
        if(this.policy[key]){
          this.policy[key].forEach(item => {
            this.policyShowList.push(item)
          })
        }
      }else{
        for(let i in this.policy){
          this.policy[i].forEach(item => {
            this.policyShowList.push(item)
          })
        }
      }
     
    },
    // 查看详情 跳转
    checkDetail(policyId){
      this.$router.push({
        path: '/policyDetail',
        query: {
          policyId: policyId
        }
      })
    },
    // 根据身份设置头像
    avatarFomatter(role){
      switch (role){
        case 1:
          return this.Storage.get('userBaseInfo').gender == 1 ? 'male' : 'female'
        case 2:
          return this.Storage.get('userBaseInfo').gender == 1 ? 'female' : 'male'
        case 3:
          return 'son'
        case 4:
          return 'daughter'
        case 5:
          return 'father'
        case 6:
          return 'mother'
        case 7:
          return 'father'
        case 8:
          return 'mother'
        case -1:
          return 'house'
        default:
          return 'other'
      }
    },
    toMemberInfo(){
      this.$router.push({
        path:'/memberInfo',
        query:{
          from:'/allPolicy'
        }
      })
    },
    toFamilyMemberList(){
      this.$router.push('/familyMemberList')
    }
  },
  created(){
    this.getFamilyMemberList()
    this.getPolicy()
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
.nopro{
  margin: 12rem auto;
  text-align: center;
}
.all-info{
  height: 100vh;
  overflow: auto;
}
.family-members{
  height: 100vh;
  position: relative;
}
.linecor{
  width:23.44rem;
  height:0.5rem;
  background:rgba(245,244,243,1);
}
 .hehe-enter,.hehe-leave-to{
    opacity: 0;
    left:100%;
  }
  .hehe-enter-to,.hehe-leave{
    opacity: 1;
    left:0;
  }
  .hehe-enter-active,.hehe-leave-active{
    transition: all 1s;
  }

 
  .tab-content{
    position: absolute;
    width: 100%;
  }

.right_arrows1 {
    width: 0.42rem;
    height:0.42rem;
    border-top: 0.02rem solid rgba(131,132,144,1);
    border-right: 0.02rem solid rgba(131,132,144,1);
    display: inline-block;
    transform: rotate(45deg);
    margin-left: 0.25rem;
}
  #all-policy{
    background: #F3F3F3;
  }
  .all-info{
    background: #fff;
    /* margin-bottom: 0.5625rem;
    padding-bottom: 0.75rem; */
  }
  .all-info .total {
    background: url(../assets/images/policy/top-bg2.png) no-repeat;
    background-size: contain;
  }
  .all-info .total .tag{
    height: 5rem;
  }
  

 .tag{
    height:5.5rem;
    display: flex;
  }
   .tag .avatar{
    width: 3rem;
    height: 3rem;
    padding: 0.1rem;
    border: 0.05rem solid white;
    border-radius: 50%;
    margin: 1.69rem 0.69rem 0 1.69rem;
  }
   .tag div{
    flex: 1;
  }
   .tag div .nickname{
    font-size: 1.25rem;
    font-weight: 600;
    height:1.69rem;
    margin-top: 1.6rem;
    color:rgba(255,255,255,1);
  }
   .tag div .related-icon{
    font-size: 0.7rem;
    color: #fff;
    display: inline-flex;
    align-items: center;
    padding: 0.03rem 0.75rem;
    background:rgba(254,134,0,1);
    border-radius: 4rem;
  }
   .tag div .related-icon > img:first-child{
    width: 0.59rem;
    margin-right: 0.42rem;
  }
   .tag div p span{
    font-size: 0.5rem;
    display: inline-flex;
    align-items: center;
    color: #ffffff;
  }
   .tag div p span img{
    width: 0.49rem;
    margin-right: 0.2rem;
  }
  
  /* .tag>span{
    display: inline-block;
    margin-top: 2.38rem;
    width: 4.06rem;
    height: 1.56rem;
    border-radius:4rem 0rem 0rem 4rem;
    background:rgba(254,234,209,1);
    font-size:0.63rem;
    text-indent: 0.94rem;
    line-height: 1.56rem;
    color:rgba(255,161,39,1);
    display: flex;
    align-items: center;
  } */

  .news{
    display: inline-block;
    margin-top: 1.69rem;
    width: 1.09rem;
    height: 1.02rem;
    display: flex;
    background: url(../assets/images/policy/news.png) no-repeat;
    background-size: 1.09rem 1.02rem;
    margin-right: 1.6rem;
  }


  .alldata{
    width:21.56rem;
    height: 13.94rem;
    background:#fff;
    margin: 1rem auto 0;
    box-shadow:0rem 0rem 1rem rgba(0,0,0,0.16);
    border-radius: 1rem;
  }

  .alldata .datatop{
    display: flex;
    justify-content: space-between;
  }
  .alldata .datatop div:first-child p:first-child{
    margin-top: 1.25rem;
    font-size:1.13rem;
    font-weight:600;
    color:rgba(49,52,71,1);
    height: 1.56rem;
    text-indent: 1.38rem;
  }
  .alldata .datatop div:first-child p:last-child{
    font-size:0.63rem;
    font-weight:400;
    color:rgba(131,132,144,1);
    height: 0.88rem;
    text-indent: 1.38rem;
  }

  .alldata .datatop div:last-child{
    width:5.31rem;
    height:1.63rem;
    margin-top: 1.38rem;
    border:0.05rem solid rgba(255,161,39,1);
    font-size:0.75rem;
    font-weight:400;
    color:rgba(255,161,39,1);
    line-height: 1.63rem;
    margin-right: 1.25rem;
    border-radius: 0.2rem;
    text-align: center;
  }

  .all-info .total .data{
    margin-top: 1.19rem;
    width:21.56rem;
    display: flex;
    justify-content: space-around;
    font-size: 0.75rem;
    font-weight: 400;
    color: #fff;
    line-height: 1.25rem;
  }
  .threesone{
    width:6.13rem;
    height:6.31rem;
    border:0.05rem solid rgba(224,224,224,1);
    border-radius:1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.19rem;
  }
 .threesone >img{
    width:2.8rem;
    height:2.8rem;
    margin-top: -1.49rem;
 }
  .threesone div {
    width: 3.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0.69rem;
  }
  .threesone div p{
    text-align: center;
    color:rgba(49,52,71,1);
  }
  .threesone div p:last-child{
    width: 4rem;
    margin-top: 0.63rem;
    color:rgba(49,52,71,1);
  }
  .threesone div p span{
    color:rgba(49,52,71,1);
    font-size: 2.125rem;
    font-weight:normal;
    display: inline-block;
    text-align: left;
    font-family: SF Pro Display;
    margin-right: 0.2rem;
  }
  .threesone div p:last-child{
    letter-spacing: 0.0625rem;
  }
  .all-info .family-members .title{
    width: 21.56rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1.3125rem auto 0;
  }
  .all-info .family-members .title span:first-child{
    padding-left: 0.625rem;
    position: relative;
    color: #4D4D4D;
    font-size: 1rem;
    font-weight: 600;
  }
  .all-info .family-members .title span:first-child::before{
    content: '';
    width: 0.1875rem;
    height: 0.8125rem;
    background: rgba(49,52,71,1);;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
  }
  .all-info .family-members .title span:last-child{
    display: flex;
    align-items: center;
    color: rgba(131,132,144,1);
    font-size: 0.8125rem;
    font-weight: 500;
  }

  .all-info .family-members ul{
    margin-bottom: 1.25rem;
    margin-left: 0.5rem;
    margin-top: 1rem;
    /* background: red; */
    height: 8.06rem;
    /* width: 100%; */
    /* overflow: hidden; */
    overflow-x: auto;
    white-space: nowrap;
  }
  .all-info .family-members ul li{
    /* background: palevioletred; */
    width: 6.13rem;
    height: 8.06rem;
    border-radius: 0.3125rem;
    margin: 0 0.5rem 0;
    overflow: hidden;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    box-sizing: border-box;
  }

   .all-info .family-members ul li.member{
    border: 1px solid #FFB165;
    transition: .5s all;
  }
  .all-info .family-members ul li.member .head{
    text-align: center;
    color: #FFF;
    background: #FFBA78;
    width: 100%;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    transition: .5s all;
  }
  .all-info .family-members ul li.member .avatar{
    width: 2.56rem;
    height: 2.56rem;
    border-radius: 0.3125rem;
    margin-top: 0.5rem;
  }
  .all-info .family-members ul li.member .name{
    font-size: 0.75rem;
    color:rgba(49,52,71,1);
    font-weight: 600;
    line-height: 0.6875rem;
    margin: 0.5625rem 0 0.4375rem;
  }
  .all-info .family-members ul li.member .intro{
    font-size: 0.75rem;
    font-weight: 500;
    color: #7B7B7B;
    line-height: 0.6875rem;
    position: absolute;
    bottom: 0.4375rem;
  }

  .all-info .family-members ul li.member .intro span{
    color: #FF9024;
  }

  .all-info .family-members ul li.member.active{
    border-color: rgba(255,161,39,1);
    box-shadow: 0 0.125rem 0.5625rem 0 rgba(89,89,89,0.19);
  }

  .all-info .family-members ul li.member.active .head{
    background: rgba(255,161,39,1);
  }

  .all-info .family-members ul li.member.active .name,
  .all-info .family-members ul li.member.active .intro{
    color: #4D4D4D;
  }
  .all-info .tagpersonl{
    display: flex;
    padding: 0 0.8125rem;
  }
  .all-info .tagpersonl .avatar{
    width: 2.5625rem;
    height: 2.5625rem;
    border-radius: 0.3125rem;
    margin-top: 0.5rem;
  }
  .all-info .tagpersonl div{
    margin-left: 0.5rem;
    color: #4d4d4d;
  }
   .all-info .tagpersonl div .name{
     margin-top: 0.5rem;
   }
   .all-info .tagpersonl div div span{
     color: #ff9024;margin-right: 0.5rem;
   }
  .all-info .family-members ul li.add{
    background: #F1EEEA;
    justify-content: center;  
  }
  .all-info .family-members ul li.add img{
    width: 1.4375rem;
  }
  .all-info .family-members ul li.add span{
    font-size:0.75rem;
    font-weight:500;
    color: #606060;
    margin-top: 0.875rem;
  }
  .list{
    background: #fff;
    padding: 1.31rem 0.8125rem;
  }
  .list .card{
    height:4.4375rem;
    background:rgba(251,249,246,1);
    border-radius: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.0625rem 1.0625rem 0.9375rem 0.875rem;
    margin-bottom: 0.875rem;
  }
  .list .card div p:first-child{
    font-size: 1rem;
    font-weight: 600;
    color:rgba(49,52,71,1);
    line-height: 1rem;
  }
  .list .card div p:last-child{
    font-size: 0.75rem;
    font-weight: 400;
    color:rgba(131,132,144,1);
    line-height: 0.6875rem;
    margin-top: 0.6875rem;
  }
  .list .card span{
    font-size:0.75rem;
    width: 3.5rem;
    font-weight: 600;
    color:rgba(255,161,39,1);
    text-align: right;
  }
</style>